import { FaAward, FaUsers, FaClock, FaStar } from "react-icons/fa";

export const stats = [
  { icon: <FaAward />, value: "50+", label: "Projects Delivered" },
  { icon: <FaUsers />, value: "30+", label: "Happy Clients" },
  { icon: <FaClock />, value: "99%", label: "On-Time Delivery" },
  { icon: <FaStar />, value: "5+", label: "Years of Excellence" },
];

export const points = [
  {
    icon: <FaAward />,
    title: "50+ Projects Delivered",
    desc: "Building scalable and reliable digital solutions.",
    gradient: "from-blue-500 to-cyan-500",
  },
  {
    icon: <FaUsers />,
    title: "30+ Happy Clients",
    desc: "Across industries and countries.",
    gradient: "from-green-500 to-teal-500",
  },
  {
    icon: <FaClock />,
    title: "99% On-Time Delivery",
    desc: "Ensuring efficiency without compromising quality.",
    gradient: "from-purple-500 to-pink-500",
  },
  {
    icon: <FaStar />,
    title: "5+ Years of Excellence",
    desc: "Driving growth with innovation.",
    gradient: "from-orange-500 to-red-500",
  },
];